const MATERIAL_MAPPING_LENGTH = 2;

export const getSelectedAllocationInitialState = () => ({
  id: 0,
  equip_id: 0,
  equip_type_id: 0,
  equip_group_id: 0,
  equip_name: '',
  priority: null,
  origin_element_id: 0,
  origin_element_point_id: 0,
  group_id: null,
  group_name: null,
  status: '',
  trucks: [],
  truck_groups: [],
  materials: Array.from({ length: MATERIAL_MAPPING_LENGTH }, () => 0),
  material_options: [],
  material_mappings: Array.from({ length: MATERIAL_MAPPING_LENGTH }, () => ({
    id: null,
    active: false,
    equip_id: null,
    equip_name: '',
    material_id: null,
    material_name: '',
    load_allocation_id: null,
    first_element_id: null,
    first_element_name: '',
    second_element_id: null,
    second_element_name: '',
    first_element_point_id: null,
    first_element_point_name: '',
    second_element_point_id: null,
    second_element_point_name: '',
  })),
  dynamic_allocation: false,
  dynamic_configuration: {
    id: null,
    group_name: '',
    max_allocation_capacity: 0,
    max_load_queue_time: 0,
    mean_queue_time_range: 0,
    min_allocation_capacity: 0,
    min_permanent_allocation_cycles: 0,
    max_temporary_allocation_cycles: 0,
  },
});

export const getUpdateLoadAllocationErrorsInitialState = () => ({
  equipId: '',
  originElementId: '',
  originElementPointId: '',
  materials: Array.from({ length: MATERIAL_MAPPING_LENGTH }, () => ({ material: '' })),
  materialMappings: Array.from({ length: MATERIAL_MAPPING_LENGTH }, () => ({
    firstElementId: '',
    firstElementPointId: '',
    secondElementId: '',
    secondElementPointId: '',
  })),
});
